/* eslint-disable no-undef */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import MapService from '../../shared/map-service';
import { scaledIcon, resolveMarkerSizes, isNearAnyPoint } from '../../shared/map-marker-icons';
import Arrival from '../../_styles/images/Arrival.svg';
import Destination from '../../_styles/images/StartVector.svg';
import Origin from '../../_styles/images/Origin.svg';
import StopMarker from '../../_styles/images/StopMarker.svg';
import CancelledStop from '../../_styles/images/new-icons/CancelledStop.svg';
import End from '../../_styles/images/End.svg';

const buildWaypointMarkers = (directions, cancelledDirections = [], sizes) => {
  const legs = directions && directions.routes && directions.routes[0] && directions.routes[0].legs;
  if (!legs || legs.length === 0) {
    return [];
  }

  const cancelledPoints = (cancelledDirections || []).map(c => ({
    lat: c.latitude,
    lng: c.longitude
  }));

  // Cancelled stops don't consume a letter, so labels run A, B, C over active stops only.
  let activeStopCount = 0;
  return legs.slice(0, -1).map(leg => {
    const lat = leg.end_location.lat();
    const lng = leg.end_location.lng();

    if (isNearAnyPoint(lat, lng, cancelledPoints)) {
      return { lat, lng, icon: scaledIcon(CancelledStop, sizes.cancelled, true) };
    }

    const index = activeStopCount++;

    return {
      lat,
      lng,
      icon: scaledIcon(StopMarker, sizes.stop, true),
      label: {
        text: String.fromCharCode('A'.charCodeAt(0) + index),
        color: '#0F2F55',
        fontWeight: '700',
        fontSize: '13px'
      }
    };
  });
};


const controlsOff = {
  zoomControl: false,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false,
  disableDefaultUI:true,
  keyboardShortcuts:false
};

class VanRouteMap extends Component {
  constructor(props) {
    super(props);
    this.state = { ready: false };
  }

  onLoad() {
    if (!this.state.ready && this.map) {
      this.setState({ ready: true });
      if (this.props.padding) {
        setTimeout(
          () =>
            this.map &&
            this.map.fitBounds(this.map.getBounds(), this.props.padding),
          200
        );
      }
    }
  }

  shouldComponentUpdate(props) {
    if (!this.state.ready) {
      return true;
    }

    if (!this.props.directions) {
      return true;
    }

    if (
      this?.props?.directions?.geocoded_waypoints?.length !==
      props?.directions?.geocoded_waypoints?.length
    ) {
      return true;
    }
    if(this.props.origin.reCenter){
      return true;
    }
    return this.props.directions.geocoded_waypoints.some((waypoint, i) => {
      const newWaypoint = props.directions.geocoded_waypoints[i];
      return newWaypoint.place_id !== waypoint.place_id;
    });
  }

  render() {
    const { directions, origin, controls = false, cancelledDirections, markerSizes } = this.props;
    const { ready } = this.state;
    const sizes = resolveMarkerSizes(markerSizes);
    var markers = [
        {
        "lat": directions ? (directions.request && directions.request.origin && directions.request.origin.location.lat()) : null,
        "lng":  directions ? (directions.request && directions.request.origin && directions.request.origin.location.lng()) : null,
        "icon" :  scaledIcon(Destination, sizes.start)
        },
        {
        "lat" :  directions ? (directions.request && directions.request.origin && directions.request.destination.location.lat()) : null,
        "lng" :  directions ? (directions.request && directions.request.origin && directions.request.destination.location.lng()) : null,
        "icon" : scaledIcon(End, sizes.end)
        },
        // {
        // "lat" :  origin ? parseFloat(origin.latitude) : null,
        // "lng" :  origin ? parseFloat(origin.longitude) : null,
        // "icon" : scaledIcon(Origin, sizes.origin)
        // },
        ...buildWaypointMarkers(directions, cancelledDirections, sizes)
      ]

    return (

      <div className={`google-map ${ready ? 'ready' : ''}`}>
        <MapService.MapWithCustomMarkers
          directions={directions}
          markers={markers}
          options={!controls ? controlsOff : null}
          mapRef={map => (this.map = map)}
          onTilesLoaded={() => this.onLoad()}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    directions: state.map && state.map.googleDirections,
    origin: state.map && state.map.origin,
    cancelledDirections: state.map && state.map.cancelledDirections
  };
}

export default connect(mapStateToProps)(VanRouteMap);
